shadow$provide[527] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Factory:{enumerable:true, get:function() {
  return Factory;
}}});
var ShaderGraph = require("shadergraph");
const Factory = function(snippets) {
  function fetch(name) {
    const s = snippets[name];
    if (s != null) {
      return s;
    }
    const ref = ["#", ".", ":", "["].includes(name[0]);
    const sel = ref ? name : `#${name}`;
    const element = document.querySelector(sel);
    if (element != null && element.tagName === "SCRIPT") {
      return element.textContent || element.innerText;
    }
    throw new Error(`Unknown shader \`${name}\``);
  }
  return ShaderGraph.load(fetch, {autoInspect:true});
};

};